module.exports = __webpack_public_path__ + "img/111.cbfd8654.jpg";